<!-- <div class="form-group" [ngClass]="{'scroll': gallery.length > 2}">
  <div class="text-center p-2 row">
    <div class="col-sm-12"> -->
<div
  class="uploader"
  [ngClass]="{
    'uploader--square': !avatarStyle
  }"
>
  <div
    ng2FileDrop
    (fileOver)="fileOverBase($event)"
    [uploader]="uploader"
    [ngClass]="{
      'uploader__drop--dropzone': !requiredBorder,
      'uploader__drop--required': requiredBorder,
      'uploader__drop--dropzone-hover': hasBaseDropZoneOver,
      'uploader__drop--error': validateError
    }"
    [ngStyle]="showAvatar && {
      'background-image': bgImage
    }"
    class="uploader__drop"
  >
    <!-- <p>Base drop zone</p> -->
    <div
      (click)="uploadFile.click()"
      class="uploader__upload"
      *ngIf="!hideInput && !config.onlyView"
    >
      <button
        *ngIf="bgImage === 'none'"
        type="button"
        class="uploader__button color-primary"
      >
        <i class="fa-thin fa-image"></i>
        {{ placeholder | translate}}
      </button>

      <input
        #uploadFile
        class="uploader__input"
        type="file"
        ng2FileSelect
        [uploader]="uploader"
        (change)="upload($event)"
      />
    </div>
    <!-- <small
              >({{type === 'medias' ? 'Images' : 'Files'}} limit
              {{uploader.options.queueLimit}})</small
            > -->

    <!--        <div class="progress">
            <div
              class="progress-bar align-self-end"
              role="progressbar"
              [ngStyle]="{ 'width': uploader.progress  ? uploader.progress + '%' : 0 }"
            ></div>
          </div> -->

    <!--<div class="gallery text-center">
            <div class="gallery--item" *ngFor="let file of gallery">
              <div class="gallery__img-wrapper">
                <div
                  class="overlay"
                  (click)="delete(file)"
                  tappable
                  *ngIf="!config.onlyView"
                >
                  <div class="close"> X </div>
                </div>
                <img
                  class="gallery__img"
                  [src]="file && file.thumbnails && file.thumbnails.small.url ? file.thumbnails.small.url : './assets/icons/file.png'"
                />
              </div>
            </div>
          </div>
        </div>
       </div>
    </div>
  </div>
   -->
  </div>

  <div *ngIf="(disclaimer || fileError) && showError">
    <p *ngIf="disclaimer">{{ disclaimer }}</p>
    <p *ngIf="fileError" class="uploader__error" translate> {{fileError}} </p>
  </div>
</div>
